import React from 'react';


const OrderRegister = React.lazy(() => import('../views/orderRegister'));
const FoodListPage = React.lazy(() => import('../views/orderRegister/foodListPage'));
const FinishRegister = React.lazy(() => import('../views/orderRegister/finishRegister'));
const LoginPage = React.lazy(() => import('../views/orderRegister/LoginPage'));
const SaderatPayment = React.lazy(() => import('../views/orderRegister/saderatPayment'));
const SaderatPaymentResult = React.lazy(() => import('../views/orderRegister/saderatPaymentResult'));
const routes = [
    {
        key: 'orderRegister',
        exact: true,
        path: '/order/register',
        component: (props: any) => <OrderRegister {...props} />,
      
    },
    {
        key: 'OrderFoodList',
        exact: true,
        path: '/order/foodList/:categoryId',
        component: (props: any) => <FoodListPage {...props} />,
      
    },
    {
        key: 'orderlogin',
        exact: true,
        path: '/order/login',
        component: (props: any) => <LoginPage {...props} />,
      
    },
    {
        key: 'FinishRegister',
        exact: true,
        path: '/order/finish',
        component: (props: any) => <FinishRegister {...props} />,
      
    },
    {
        key: 'SaderatPayment',
        exact: true,
        path: '/order/saderatPayment/:token/:amount',
        component: (props: any) => <SaderatPayment {...props} />,
      
    },
    {
        key: 'SaderatPayment',
        exact: true,
        path: '/order/saderatPaymentResult/:result',
        component: (props: any) => <SaderatPaymentResult {...props} />,
      
    },
]

export default routes;